import React from 'react';
import './address-form-skeleton.scss';

const AddressFormSkeleton: React.FC = () => {
    return (
        <div
            className="osb-v3-address-form-skeleton-container"
            data-testid="address-form-skeleton"
        >
            <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-title"></div>

            <form>
                <div className="osb-v3-address-form-skeleton-form-group">
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                </div>

                <div className="osb-v3-address-form-skeleton-form-group">
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                </div>

                <div className="osb-v3-address-form-skeleton-form-group">
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                </div>

                <div className="osb-v3-address-form-skeleton-form-row">
                    <div className="osb-v3-address-form-skeleton-form-group osb-v3-address-form-skeleton-postcode-group">
                        <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                        <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                    </div>
                    <div className="osb-v3-address-form-skeleton-form-group">
                        <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                        <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                    </div>
                </div>

                <div className="osb-v3-address-form-skeleton-form-group">
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-input"></div>
                </div>

                <div className="osb-v3-address-form-skeleton-form-group">
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-label"></div>
                    <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-comment-box"></div>
                </div>
            </form>

            <div className="osb-v3-address-form-skeleton osb-v3-address-form-skeleton-link"></div>
        </div>
    );
};

export default AddressFormSkeleton;
